import * as Preact from 'preact';
import { Box } from '@mui/material';
import * as Button from './A_Button';
import * as IconButton from './A_IconButton';
import ShareIcon from '@mui/icons-material/Share';

export interface Action {
    icon?: (props?: any) => Preact.JSX.Element;
    actionText: string;
    onActionClick: () => void;
    actionLoading?: boolean;
    disabled?: boolean;
}

export interface Props {
    onShareClick?: () => void;
    primary?: Action;
    secondary?: Action;
}

export const Component = (props: Props) => {
    return (
        <Box
            sx={{
                display: 'flex',
                gap: '8px',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
            }}
        >
            {props.onShareClick && (
                <IconButton.Component size="medium" color="secondary" onClick={props.onShareClick}>
                    <ShareIcon fontSize="small" />
                </IconButton.Component>
            )}
            {props.secondary && (
                <Button.Component
                    size="medium"
                    color="secondary"
                    variant="outlined"
                    disabled={props.secondary.disabled}
                    onClick={props.secondary.onActionClick}
                    startIcon={props.secondary.icon}
                    sx={{ width: { xs: '100%', md: 'auto' } }}
                >
                    {props.secondary.actionText}
                </Button.Component>
            )}
            {props.primary && (
                <Button.Component
                    size="medium"
                    color="primary"
                    variant="contained"
                    disabled={props.primary.disabled}
                    onClick={props.primary.onActionClick}
                    loading={props.primary.actionLoading ?? false}
                    startIcon={props.primary.icon}
                    sx={{ width: { xs: '100%', md: 'auto' } }}
                >
                    {props.primary.actionText}
                </Button.Component>
            )}
        </Box>
    );
};

Component.displayName = 'CTACombo';
